/**
 *
 *  ROLES:
 *  {
 *      1: Administrador
 *      2: Consultor
 *      3: Empresa
 *      4: Coordenador
 *      5: Supervisor
 *  }
 *
 * @type {[{path: string, labelFull: string, allowedRoles: number[], iconType: string, icon: JSX.Element, label: string},{path: string, labelFull: string, iconType: string, icon: JSX.Element, label: string},{path: string, labelFull: string, iconType: string, icon: JSX.Element, label: string},{path: string, labelFull: string, iconType: string, icon: JSX.Element, label: string},{path: string, labelFull: string, iconType: string, icon: JSX.Element, label: string}]}
 */

const sidebarData = (role, existConsultantId, enterpriseId) => [
    {
        label: 'Home',
        labelFull: 'Home',
        path: `/${role}`,
        icon: (
            <>
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M15 23V17C15 16.7348 14.8946 16.4805 14.7071 16.2929C14.5196 16.1054 14.2652 16 14 16H10C9.73478 16 9.48043 16.1054 9.29289 16.2929C9.10536 16.4805 9 16.7348 9 17V23C9 23.2652 8.89464 23.5196 8.70711 23.7071C8.51957 23.8947 8.26522 24 8 24H2C1.73478 24 1.48043 23.8947 1.29289 23.7071C1.10536 23.5196 1 23.2652 1 23V11.4375C1.00224 11.2991 1.03215 11.1626 1.08796 11.0359C1.14378 10.9093 1.22437 10.7951 1.325 10.7L11.325 1.61252C11.5093 1.44387 11.7501 1.35034 12 1.35034C12.2499 1.35034 12.4907 1.44387 12.675 1.61252L22.675 10.7C22.7756 10.7951 22.8562 10.9093 22.912 11.0359C22.9679 11.1626 22.9978 11.2991 23 11.4375V23C23 23.2652 22.8946 23.5196 22.7071 23.7071C22.5196 23.8947 22.2652 24 22 24H16C15.7348 24 15.4804 23.8947 15.2929 23.7071C15.1054 23.5196 15 23.2652 15 23Z"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </>
        ),
        iconType: 'stroke',
        allowedRoles: [2, 3, 7].concat(existConsultantId)
    },
    {
        label: 'Propriedades',
        labelFull: 'Minhas Propriedades',
        dataTour: '3',
        path: `/${role}/propriedades`,
        icon: (
            <>
                <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.5584 1.38114C14.7825 1.3078 15.0252 1.31596 15.2438 1.40419L24.0672 4.96525C24.2584 5.04243 24.4211 5.17684 24.533 5.35006L28.5627 11.5899C28.8968 12.1073 28.6883 12.8009 28.1242 13.0482L26.9644 13.5568C26.515 13.7539 25.9889 13.5958 25.7227 13.1835L21.9965 7.41369C21.8731 7.22262 21.6883 7.07932 21.4724 7.00744L15.2122 4.92238C15.0087 4.85462 14.7889 4.85405 14.5851 4.92077L8.20744 7.0086C7.98743 7.08063 7.79923 7.22675 7.67493 7.42205L4.01512 13.1724C3.75127 13.587 3.22531 13.7484 2.77432 13.5532L1.64223 13.0633C1.06653 12.8141 0.859718 12.1026 1.21218 11.5837L6.11543 4.36467C6.23974 4.18164 6.42126 4.045 6.63153 3.97616L14.5584 1.38114Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M9.61816 14.7285L20.2565 25.6718" stroke="white" strokeWidth="2" />
                    <path d="M20.2568 14.7285L9.61854 25.6718" stroke="white" strokeWidth="2" />
                    <path
                        d="M9.47656 14.5859H20.2567V25.8129H9.47656V14.5859Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M2.66797 25.8145H27.0651" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M3.80273 13.6152V25.5301" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M26.2139 13.6152V25.5301" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </>
        ),
        iconType: 'stroke',
        allowedRoles: [2, 3, 7].concat(existConsultantId)
    },
    {
        label: 'Agenda',
        labelFull: 'Agenda do Consultor',
        path: `/${role}/agenda`,
        icon: (
            <>
                <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M22 3H2C1.44772 3 1 3.44772 1 4V24C1 24.5523 1.44772 25 2 25H22C22.5523 25 23 24.5523 23 24V4C23 3.44772 22.5523 3 22 3Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M18 1V5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6 1V5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1 9H23" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M7.5 14H11L9 16.5C9.32915 16.4994 9.65335 16.5801 9.94384 16.7349C10.2343 16.8897 10.4821 17.1137 10.6653 17.3872C10.8484 17.6607 10.9612 17.9752 10.9937 18.3027C11.0261 18.6303 10.9773 18.9608 10.8514 19.2649C10.7255 19.569 10.5265 19.8374 10.272 20.0462C10.0176 20.2549 9.71552 20.3977 9.39266 20.4618C9.06981 20.5258 8.73613 20.5092 8.42124 20.4134C8.10634 20.3176 7.81996 20.1455 7.5875 19.9125"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M14 15.5L16 14V20.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </>
        ),
        iconType: 'stroke',
        allowedRoles: [2, 3].concat(existConsultantId)
    },
    // {
    //     label: 'Mentorias',
    //     labelFull: 'Mentorias',
    //     path: `/${role}/mentorias`,
    //     icon: (
    //         <>
    //             <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                 <path
    //                     d="M6.75 19.1625L2.6375 22.6125C2.49181 22.7331 2.31493 22.8098 2.12737 22.8339C1.93981 22.858 1.74927 22.8284 1.57784 22.7486C1.40642 22.6688 1.26114 22.542 1.15886 22.3829C1.05658 22.2239 1.0015 22.0391 1 21.85V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H24C24.2652 1 24.5196 1.10536 24.7071 1.29289C24.8946 1.48043 25 1.73478 25 2V18C25 18.2652 24.8946 18.5196 24.7071 18.7071C24.5196 18.8946 24.2652 19 24 19H7.2125L6.75 19.1625Z"
    //                     stroke="white"
    //                     strokeWidth="2"
    //                     strokeLinecap="round"
    //                     strokeLinejoin="round"
    //                 />
    //                 <path d="M9 8H17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    //                 <path d="M9 12H17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    //             </svg>
    //         </>
    //     ),
    //     iconType: 'stroke',
    //     allowedRoles: [2, 3]
    // },
    {
        label: 'Administrativo',
        labelFull: 'Painel Administrativo',
        path: `/${role}/painel`,
        icon: (
            <>
                <svg width="30" height="27" viewBox="0 0 122.88 121.78" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.91,0H49.79a6.84,6.84,0,0,1,3,.67,7,7,0,0,1,2.39,1.88A6.54,6.54,0,0,1,56.29,4.6a6.61,6.61,0,0,1,.41,2.31V49.6a7,7,0,0,1-.55,2.7,6.82,6.82,0,0,1-1.58,2.27,6.93,6.93,0,0,1-4.78,2H6.91A6.93,6.93,0,0,1,4.37,56a6.93,6.93,0,0,1-2.21-1.4A7.06,7.06,0,0,1,.58,52.33,6.65,6.65,0,0,1,0,49.6V6.91A6.84,6.84,0,0,1,.45,4.49,6.81,6.81,0,0,1,1.71,2.37L2,2.09A7.1,7.1,0,0,1,4.06.63,7,7,0,0,1,6.91,0ZM112.78,72.3a2.63,2.63,0,0,0-2-.83,2.6,2.6,0,0,0-1.94.83l-3,3a18.39,18.39,0,0,0-2.51-1.37,26.73,26.73,0,0,0-2.69-1V68.29a2.62,2.62,0,0,0-.8-2,2.65,2.65,0,0,0-2-.79H92.25a2.68,2.68,0,0,0-1.92.79,2.64,2.64,0,0,0-.82,2v4.17a21.05,21.05,0,0,0-5.32,2L80.9,71.25A2.51,2.51,0,0,0,79,70.42a2.67,2.67,0,0,0-1.94.83l-4,4a2.71,2.71,0,0,0,0,3.9l3,3a19.12,19.12,0,0,0-1.37,2.52,26.73,26.73,0,0,0-1,2.69H69a2.62,2.62,0,0,0-2,.8,2.66,2.66,0,0,0-.8,2v5.71a2.69,2.69,0,0,0,.8,1.92,2.64,2.64,0,0,0,2,.82h4.17a19.75,19.75,0,0,0,.85,2.77,25.64,25.64,0,0,0,1.18,2.61L72,107.14a2.52,2.52,0,0,0-.83,1.9A2.67,2.67,0,0,0,72,111l4,4.06a2.84,2.84,0,0,0,3.89,0l3-3a20.3,20.3,0,0,0,2.52,1.36,24.54,24.54,0,0,0,2.69,1V119a2.62,2.62,0,0,0,.8,2,2.65,2.65,0,0,0,1.94.8h5.72a2.69,2.69,0,0,0,1.92-.8,2.64,2.64,0,0,0,.82-2v-4.17a19.75,19.75,0,0,0,2.77-.85,23.63,23.63,0,0,0,2.61-1.18l3.23,3.24a2.65,2.65,0,0,0,3.85,0l4.06-4a2.81,2.81,0,0,0,.77-2,2.76,2.76,0,0,0-.77-2l-3-3a19.12,19.12,0,0,0,1.37-2.52,26.73,26.73,0,0,0,1-2.69h4.55a2.66,2.66,0,0,0,2-.8,2.62,2.62,0,0,0,.8-2V91.5a2.75,2.75,0,0,0-2.75-2.73h-4.17a21.74,21.74,0,0,0-.85-2.75,21.19,21.19,0,0,0-1.18-2.59l3.24-3.28a2.52,2.52,0,0,0,.83-1.9,2.67,2.67,0,0,0-.83-2l-4-4ZM94.39,82.45a11.14,11.14,0,0,1,4.37.87,11.06,11.06,0,0,1,6,6,11.39,11.39,0,0,1,0,8.73,11.06,11.06,0,0,1-6,6A11.39,11.39,0,0,1,90,104a11.06,11.06,0,0,1-6-6,11.39,11.39,0,0,1,0-8.73,11.06,11.06,0,0,1,6-6,11.13,11.13,0,0,1,4.36-.87ZM6.91,65.26H49.79a6.84,6.84,0,0,1,3,.67,7.15,7.15,0,0,1,2.39,1.88,6.54,6.54,0,0,1,1.15,2,6.65,6.65,0,0,1,.41,2.31v42.7a7.08,7.08,0,0,1-.55,2.7,7,7,0,0,1-3.79,3.7,6.81,6.81,0,0,1-2.57.51H6.91a6.92,6.92,0,0,1-2.54-.5,6.79,6.79,0,0,1-2.21-1.41,7.06,7.06,0,0,1-1.58-2.28A6.61,6.61,0,0,1,0,114.87V72.17a7,7,0,0,1,1.71-4.53L2,67.35a7.1,7.1,0,0,1,2.08-1.46,7,7,0,0,1,2.85-.63Zm42.88,6.89H6.91l0,0,0,42.72c3.67,0,42.89,0,42.92,0,0-3.6,0-42.7,0-42.72ZM73.09,0H116a6.87,6.87,0,0,1,3,.67,7,7,0,0,1,2.38,1.88,6.77,6.77,0,0,1,1.16,2.05,6.61,6.61,0,0,1,.41,2.31V49.6a6.83,6.83,0,0,1-.56,2.7,6.94,6.94,0,0,1-1.57,2.27A7,7,0,0,1,118.53,56a6.91,6.91,0,0,1-2.56.51H73.09a7.14,7.14,0,0,1-4.75-1.91,7.09,7.09,0,0,1-1.59-2.28,6.81,6.81,0,0,1-.57-2.73V6.91a6.84,6.84,0,0,1,.45-2.42,6.79,6.79,0,0,1,1.25-2.12l.28-.28A7.19,7.19,0,0,1,70.23.63,7,7,0,0,1,73.09,0ZM116,6.89H73.09l0,0V49.63c3.68,0,42.89,0,42.93,0,0-3.61,0-42.71,0-42.72Zm-66.18,0H6.91l0,0,0,42.72c3.67,0,42.89,0,42.92,0,0-3.61,0-42.71,0-42.72Z"
                        fill="#fffefe"
                    />
                </svg>
            </>
        ),
        iconType: 'stroke',
        allowedRoles: [1, 6]
    },
    {
        label: 'Administrativo',
        labelFull: 'Painel Administrativo',
        path: `/${role}/empresa/geral/${enterpriseId}`,
        icon: (
            <>
                <svg width="30" height="27" viewBox="0 0 122.88 121.78" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.91,0H49.79a6.84,6.84,0,0,1,3,.67,7,7,0,0,1,2.39,1.88A6.54,6.54,0,0,1,56.29,4.6a6.61,6.61,0,0,1,.41,2.31V49.6a7,7,0,0,1-.55,2.7,6.82,6.82,0,0,1-1.58,2.27,6.93,6.93,0,0,1-4.78,2H6.91A6.93,6.93,0,0,1,4.37,56a6.93,6.93,0,0,1-2.21-1.4A7.06,7.06,0,0,1,.58,52.33,6.65,6.65,0,0,1,0,49.6V6.91A6.84,6.84,0,0,1,.45,4.49,6.81,6.81,0,0,1,1.71,2.37L2,2.09A7.1,7.1,0,0,1,4.06.63,7,7,0,0,1,6.91,0ZM112.78,72.3a2.63,2.63,0,0,0-2-.83,2.6,2.6,0,0,0-1.94.83l-3,3a18.39,18.39,0,0,0-2.51-1.37,26.73,26.73,0,0,0-2.69-1V68.29a2.62,2.62,0,0,0-.8-2,2.65,2.65,0,0,0-2-.79H92.25a2.68,2.68,0,0,0-1.92.79,2.64,2.64,0,0,0-.82,2v4.17a21.05,21.05,0,0,0-5.32,2L80.9,71.25A2.51,2.51,0,0,0,79,70.42a2.67,2.67,0,0,0-1.94.83l-4,4a2.71,2.71,0,0,0,0,3.9l3,3a19.12,19.12,0,0,0-1.37,2.52,26.73,26.73,0,0,0-1,2.69H69a2.62,2.62,0,0,0-2,.8,2.66,2.66,0,0,0-.8,2v5.71a2.69,2.69,0,0,0,.8,1.92,2.64,2.64,0,0,0,2,.82h4.17a19.75,19.75,0,0,0,.85,2.77,25.64,25.64,0,0,0,1.18,2.61L72,107.14a2.52,2.52,0,0,0-.83,1.9A2.67,2.67,0,0,0,72,111l4,4.06a2.84,2.84,0,0,0,3.89,0l3-3a20.3,20.3,0,0,0,2.52,1.36,24.54,24.54,0,0,0,2.69,1V119a2.62,2.62,0,0,0,.8,2,2.65,2.65,0,0,0,1.94.8h5.72a2.69,2.69,0,0,0,1.92-.8,2.64,2.64,0,0,0,.82-2v-4.17a19.75,19.75,0,0,0,2.77-.85,23.63,23.63,0,0,0,2.61-1.18l3.23,3.24a2.65,2.65,0,0,0,3.85,0l4.06-4a2.81,2.81,0,0,0,.77-2,2.76,2.76,0,0,0-.77-2l-3-3a19.12,19.12,0,0,0,1.37-2.52,26.73,26.73,0,0,0,1-2.69h4.55a2.66,2.66,0,0,0,2-.8,2.62,2.62,0,0,0,.8-2V91.5a2.75,2.75,0,0,0-2.75-2.73h-4.17a21.74,21.74,0,0,0-.85-2.75,21.19,21.19,0,0,0-1.18-2.59l3.24-3.28a2.52,2.52,0,0,0,.83-1.9,2.67,2.67,0,0,0-.83-2l-4-4ZM94.39,82.45a11.14,11.14,0,0,1,4.37.87,11.06,11.06,0,0,1,6,6,11.39,11.39,0,0,1,0,8.73,11.06,11.06,0,0,1-6,6A11.39,11.39,0,0,1,90,104a11.06,11.06,0,0,1-6-6,11.39,11.39,0,0,1,0-8.73,11.06,11.06,0,0,1,6-6,11.13,11.13,0,0,1,4.36-.87ZM6.91,65.26H49.79a6.84,6.84,0,0,1,3,.67,7.15,7.15,0,0,1,2.39,1.88,6.54,6.54,0,0,1,1.15,2,6.65,6.65,0,0,1,.41,2.31v42.7a7.08,7.08,0,0,1-.55,2.7,7,7,0,0,1-3.79,3.7,6.81,6.81,0,0,1-2.57.51H6.91a6.92,6.92,0,0,1-2.54-.5,6.79,6.79,0,0,1-2.21-1.41,7.06,7.06,0,0,1-1.58-2.28A6.61,6.61,0,0,1,0,114.87V72.17a7,7,0,0,1,1.71-4.53L2,67.35a7.1,7.1,0,0,1,2.08-1.46,7,7,0,0,1,2.85-.63Zm42.88,6.89H6.91l0,0,0,42.72c3.67,0,42.89,0,42.92,0,0-3.6,0-42.7,0-42.72ZM73.09,0H116a6.87,6.87,0,0,1,3,.67,7,7,0,0,1,2.38,1.88,6.77,6.77,0,0,1,1.16,2.05,6.61,6.61,0,0,1,.41,2.31V49.6a6.83,6.83,0,0,1-.56,2.7,6.94,6.94,0,0,1-1.57,2.27A7,7,0,0,1,118.53,56a6.91,6.91,0,0,1-2.56.51H73.09a7.14,7.14,0,0,1-4.75-1.91,7.09,7.09,0,0,1-1.59-2.28,6.81,6.81,0,0,1-.57-2.73V6.91a6.84,6.84,0,0,1,.45-2.42,6.79,6.79,0,0,1,1.25-2.12l.28-.28A7.19,7.19,0,0,1,70.23.63,7,7,0,0,1,73.09,0ZM116,6.89H73.09l0,0V49.63c3.68,0,42.89,0,42.93,0,0-3.61,0-42.71,0-42.72Zm-66.18,0H6.91l0,0,0,42.72c3.67,0,42.89,0,42.92,0,0-3.61,0-42.71,0-42.72Z"
                        fill="#fffefe"
                    />
                </svg>
            </>
        ),
        iconType: 'stroke',
        allowedRoles: [4, 5]
    },
    {
        label: 'Saber Mais',
        labelFull: 'Saber Mais',
        path: `/${role}/glossario`,
        icon: (
            <>
                <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14 5C14 3.93913 14.4214 2.92172 15.1716 2.17157C15.9217 1.42143 16.9391 1 18 1H26C26.2652 1 26.5196 1.10536 26.7071 1.29289C26.8946 1.48043 27 1.73478 27 2V18C27 18.2652 26.8946 18.5196 26.7071 18.7071C26.5196 18.8946 26.2652 19 26 19H18C16.9391 19 15.9217 19.4214 15.1716 20.1716C14.4214 20.9217 14 21.9391 14 23"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M1 18C1 18.2652 1.10536 18.5196 1.29289 18.7071C1.48043 18.8946 1.73478 19 2 19H10C11.0609 19 12.0783 19.4214 12.8284 20.1716C13.5786 20.9217 14 21.9391 14 23V5C14 3.93913 13.5786 2.92172 12.8284 2.17157C12.0783 1.42143 11.0609 1 10 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V18Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M18 6H23" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M18 10H23" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M18 14H23" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </>
        ),
        iconType: 'stroke',
        allowedRoles: [1, 2, 3, 4, 5, 6],
        hideForEnterprise: []
    },
    {
        label: 'Ao vivo',
        labelFull: 'Encontros ao vivo',
        path: `/${role}/encontros-ao-vivo`,
        icon: (
            <>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_2003_631)">
                        <path
                            d="M24 8H4C3.44772 8 3 8.44772 3 9V23C3 23.5523 3.44772 24 4 24H24C24.5523 24 25 23.5523 25 23V9C25 8.44772 24.5523 8 24 8Z"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M25 14L31 10V22L25 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_2003_631">
                            <rect width="32" height="32" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </>
        ),
        iconType: 'stroke',
        allowedRoles: [1, 2, 3, 4, 5, 6]
    }
];
export default sidebarData;
